import React, { useEffect, useState } from 'react'
import { Modal, Form, Input, Select, Row, Col, Button, Checkbox, Tabs, notification } from 'antd';
import { CopyOutlined } from "@ant-design/icons";
import axios from 'axios';
import { DEV_MODE, THREEDS_URL } from '../../config/config';
import Swal from 'sweetalert2';
import Cookies from "js-cookie";
import CatchError from '../../helper/CatchError';
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import GroupAccess from '../../helper/GroupAccess';
const { TextArea } = Input;

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

const { Option } = Select;

const AddMerchantModal = (props) => {

    const { t, isAddMerchantModalVisible, setIsAddMerchantModalVisible, countryList, merchantData, reloadTable, clientModeOption, enableResultOption, disableChallengeOption, authenticationIndicatorOption, challengeIndicatorOption, accountTypeOption, messageCategoryOption, transactionTypeOption, currencyList } = props;
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState();
    const [apiToken, setApiToken] = useState(null);
    const [isLoadingGenApiToken, setIsLoadingGenApiToken] = useState(false);
    const [providers, setProviders] = useState([]);

    useEffect(() => {

        if(!isAddMerchantModalVisible){
            return;
        }

         const headers = {
            Authorization: `Bearer ${Cookies.get('threeds_token')}`,
        };

        if (merchantData) {

            const fetchMerchantDetails = async () => {
                try {
                    const [merchantRes, tokenRes, providerRes] = await Promise.all([
                        axios.get(
                            `${THREEDS_URL}/api/v1/merchant/${merchantData.mid}/details`,
                            { headers }
                        ),
                        axios.get(
                            `${THREEDS_URL}/api/v1/merchant/${merchantData.mid}/tokens?active=1`,
                            { headers }
                        ),
                        axios.post(
                            `${THREEDS_URL}/api/v1/providers/summary`,
                            null,
                            { headers }
                        )
                    ]);

                    const data = merchantRes.data;

                    if (data?.status?.toLowerCase() !== 'ok') {
                        throw new Error('Unable to fetch merchant details');
                    }

                    if(!tokenRes.data?.list?.[0]?.token) {
                        throw new Error('Unable to fetch merchant api token');
                    }

                    if(!providerRes.data || !Array.isArray(providerRes.data)) {
                        throw new Error('Unable to fetch providers');
                    }

                    const m = data.details;

                    if (!providerRes.data.find(provider => provider.provider_id === m.provider_id)) {
                        throw new Error('The provider associated with this merchant was not found.');
                    }

                    form.setFieldsValue({
                        rcode: m?.rcode,
                        name: m?.site_name,
                        description: m?.description,
                        contact: m?.contact,
                        remarks: m?.remarks,
                        status: m?.status,
                        verbose: Boolean(m?.verbose),
                        client_mode: m?.clientMode,
                        enable_result: m?.enableResult,
                        disable_challenge: m?.disableChallenge,
                        requestor_name: m?.requestorName,
                        requestor_url: m?.requestorURL,
                        authentication_ind: m?.authenticationInd,
                        challenge_ind: m?.challengeInd,
                        acct_type: m?.acctType,
                        acquirer_merchant_pwd: m?.acquirerMerchantPwd,
                        mcc: m?.mcc,
                        merchant_country_code: m?.merchantCountryCode,
                        message_category: m?.messageCategory,
                        purchase_currency: m?.purchaseCurrency ? String(m.purchaseCurrency).split(',').map(v => v.trim()) : [],
                        trans_type: m?.transType,
                        provider_id: m?.provider_id,
                    });

                    setApiToken(tokenRes.data?.list?.[0]?.token);
                    setProviders(providerRes.data);

                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: error?.message || 'Something went wrong',
                        showConfirmButton: true,
                        timer: 2000,
                        onClose: () => {
                            setIsAddMerchantModalVisible(false);
                        },
                    });
                }
            }

            fetchMerchantDetails();

        } else {

            const fetchProviders = async () => {
                try {
                    const [providerRes] = await Promise.all([
                        axios.post(
                            `${THREEDS_URL}/api/v1/providers/summary`,
                            null,
                            { headers }
                        )
                    ]);

                    if(!providerRes.data || !Array.isArray(providerRes.data)) {
                        throw new Error('Unable to fetch providers');
                    }

                    setProviders(providerRes.data);

                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: error?.message || 'Something went wrong',
                        showConfirmButton: true,
                        timer: 2000,
                        onClose: () => {
                            setIsAddMerchantModalVisible(false);
                        },
                    });
                }
            }
            fetchProviders();
            form.setFieldsValue({
                name: null,
                description: null,
                contact: null,
                remarks: null,
                status: 'active',
                verbose: null,
                client_mode: '2',
                enable_result: 'Y',
                disable_challenge: 'N',
                requestor_name: null,
                requestor_url: null,
                "authentication_ind": '01',
                "challenge_ind": '01',
                acct_type: '01',
                visaAcquirerBin: null,
                visaAcquirerMid: null,
                masterAcquirerBin: null,
                masterAcquirerMid: null,
                JCBAcquirerBin: null,
                JCBAcquirerMid: null,
                CUPAcquirerBin: null,
                CUPAcquirerMid: null,
                AMEXAcquirerBin: null,
                AMEXAcquirerMid: null,
                acquirer_merchant_pwd: null,
                mcc: null,
                merchant_country_code: null,
                merchant_name: null,
                message_category: '01',
                purchase_currency: [],
                trans_type: '01',
                provider_id: '',
            })
        }

    }, [merchantData, form, isAddMerchantModalVisible])  // eslint-disable-line react-hooks/exhaustive-deps

    const handleCancel = () => {
        setIsAddMerchantModalVisible(false);
    }

    const handleSubmit = () => {
        if (!GroupAccess('SYSADMIN'))
            return;

        setIsLoading(true);
        form.validateFields().then((values) => {

            // UNSET NOT NEEDED DATA FOR EDIT MERCHANT
            if (merchantData) {
                delete values.rcode
                delete values.visaAcquirerBin
                delete values.visaAcquirerMid
                delete values.masterAcquirerBin
                delete values.masterAcquirerMid
                delete values.JCBAcquirerBin
                delete values.JCBAcquirerMid
                delete values.CUPAcquirerBin
                delete values.CUPAcquirerMid
                delete values.AMEXAcquirerBin
                delete values.AMEXAcquirerMid
            }

            let route = (merchantData) ? `${merchantData.mid}/edit` : 'create';
            const apiUrl = THREEDS_URL + '/api/v1/merchant/' + route;
            axios
                .post(apiUrl, values, { headers: { Authorization: "Bearer " + Cookies.get("threeds_token") } })
                .then(({ data }) => {
                    if (data?.status.toLowerCase() === 'ok') {
                        form.resetFields();
                        setIsAddMerchantModalVisible(false);
                        setIsLoading(false);
                        Swal.fire({
                            icon: 'success',
                            title: (merchantData) ? '3DS merchant updated' : '3DS merchant created',
                            text: data.link,
                            showConfirmButton: false,
                            timer: 2000,
                            onClose: () => {
                                reloadTable()
                            }
                        })
                    } else {
                        setIsLoading(false);
                        CatchError("Unable to " + (merchantData ? "update" : "create") + " 3ds merchant.")
                    }
                }).catch((error) => {
                    setIsLoading(false);
                    let errorText = error.response ? error.response.data.error_msg['msg'] : "Unable to " + (merchantData ? 'update' : 'create') + " 3ds merchant.";
                    CatchError(errorText)
                })
        }).catch((info) => {
            setIsLoading(false);
        })
    }

    const formItemStyle = {
        marginBottom: "10px"
    };

    const generateNewToken = () => {
        setIsLoadingGenApiToken(true);
        const apiUrl = '/api/v1/merchant/' + merchantData.mid + '/generateJWTToken';
        Swal.fire({
            icon: "info",
            title: "Warning! Generate API Token",
            text: 'This will generate a new API Token. When you generate a new API Token your old key will be invalid. This will mean that until the new token is added, none of the API calls will be validated.',
            timer: 0,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Generate New API Token'
        }).then((res) => {
            if (res.isConfirmed) { // Show Confirmation Modal
                Swal.fire({
                    icon: "info",
                    title: "Are you sure you want to do this, it will invalidate your old API Token.",
                    timer: 0,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    cancelButtonText: 'No',
                    confirmButtonText: 'Yes'
                }).then((res) => {
                    if (res.isConfirmed) { // Generate New Token Request
                        setIsLoadingGenApiToken(true);
                        axios
                            .post(THREEDS_URL + apiUrl, {}, { headers: { Authorization: "Bearer " + Cookies.get("threeds_token") } })
                            .then((result) => {
                                
                                setApiToken(result.data.jwt_token);
                                Swal.fire({
                                    icon: "success",
                                    title: "New API Token Successfully Generated.",
                                    showConfirmButton: false,
                                    timer: 2000,
                                });
                            })
                            .catch((error) => {
                                Swal.fire({
                                    icon: "error",
                                    title: "Oops...",
                                    text: t("login.dialogs.catch"),
                                    showConfirmButton: false,
                                    timer: 2000,
                                });
                            }).finally(() => {
                                setIsLoadingGenApiToken(false);
                            });
                    }
                })
            }
            setIsLoadingGenApiToken(false);
        });
    }

    return (
        <Modal
            forceRender={true}
            title={merchantData ? (GroupAccess('SYSADMIN') ? t("contents._3dsecure_merchant.edit_merchant") : t("contents._3dsecure_merchant.title")) : t("contents._3dsecure_merchant.new_merchant")}
            width="1176"
            style={{
                maxWidth: "1176px"
            }}
            visible={isAddMerchantModalVisible}
            onOk={handleSubmit}
            okText={"Submit"}
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={() => handleCancel()}>
                    {t("contents.3dsecure.form.cancel")}
                </Button>,
                ...GroupAccess('SYSADMIN') ? [<Button key="submit" type="primary" onClick={handleSubmit} htmlType="submit" loading={isLoading}>
                    {t("contents.3dsecure.form.submit")}
                </Button>] : []
            ]}
        >

            <Form  {...{
                labelCol: { span: 7 },
                wrapperCol: { span: 17 },
                layout: "horizontal",
                size: "middle",
                labelAlign: "left",
                labelWrap: false,
                requiredMark: true,
                colon: false,
                style: { padding: "10px 0" }
            }}
                form={form}
            >

                <Row justify="space-around">
                    <Col lg={23}>

                        {
                            // TEST LINK
                            merchantData && DEV_MODE ?
                                <div>
                                    <Button type="primary" ghost href={THREEDS_URL + "/sdk/test/3ds2DemoPaymentPage.php?mid=" + merchantData?.mid} target='_blank'> Load Test Page </Button>
                                </div>
                                : null
                        }

                        {
                            // RCODE INPUT
                            merchantData ?
                                <Form.Item style={formItemStyle} name='rcode' label={
                                    <span>
                                        {t('contents._3dsecure_merchant.form.rcode')}
                                        <Button style={{ border: 'none' }}
                                            size="small"
                                            icon={<CopyOutlined style={{ color: "#2989FF" }} />}
                                            onClick={() => {
                                                // Show Toast
                                                notification.success({
                                                    message: 'Rcode copied',
                                                    placement: 'bottom',
                                                    duration: 1
                                                })
                                                navigator.clipboard.writeText(merchantData.rcode);
                                            }}
                                        />
                                    </span>

                                } >
                                    <Input disabled />
                                </Form.Item> : null
                        }

                        {/* NAME INPUT */}
                        <Form.Item style={formItemStyle} name="name" label={t('contents._3dsecure_merchant.form.dba_name')} rules={[{ required: true, message: t('required_field') }]}>
                            <Input />
                        </Form.Item>

                        {
                            // Fields to display for non-sysadmin
                            !GroupAccess('SYSADMIN') ? <>
                                <Form.Item style={formItemStyle} name="requestor_url" label={t('contents._3dsecure_merchant.form.sales_url')}>
                                    <Input />
                                </Form.Item>

                                <Form.Item name="disable_challenge" label={t('contents._3dsecure_merchant.form.disable_challenge')}>
                                    <Select>
                                        {disableChallengeOption.map((item, index) => (
                                            <Option key={item.key} value={item.value}> {item.label} </Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item name="trans_type" label={t('contents._3dsecure_merchant.form.transaction_type')}>
                                    <Select>
                                        {transactionTypeOption.map((item, index) => (
                                            <Option key={item.key} value={item.value}> {item.label} </Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item name="authentication_ind" label={t('contents._3dsecure_merchant.form.3DS_requestor_authentication_indicator')}>
                                    <Select>
                                        {authenticationIndicatorOption.map((item, index) => (
                                            <Option key={item.key} value={item.value}> {item.label} </Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item name="challenge_ind" label={t('contents._3dsecure_merchant.form.3DS_requestor_challenge_indicator')}>
                                    <Select>
                                        {challengeIndicatorOption.map((item, index) => (
                                            <Option key={item.key} value={item.value}> {item.label} </Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item style={formItemStyle} name="mcc" label={t('contents._3dsecure_merchant.form.merchant_category_code')}>
                                    <Input />
                                </Form.Item>

                                <Form.Item style={formItemStyle} name="merchant_country_code" label={t('contents._3dsecure_merchant.form.merchant_country_code')}>
                                    <Select
                                    >
                                        {countryList
                                            ?
                                            Object.keys(countryList).map((item, index) => (
                                                <Option key={index} value={countryList[index].abrv_numeric}> {countryList[index].name} - {countryList[index].abrv_numeric} </Option>
                                            ))
                                            : null
                                        }
                                    </Select>
                                </Form.Item>

                                <Form.Item style={formItemStyle} name="purchase_currency" label={t('contents._3dsecure_merchant.form.purchase_currency')}>
                                    <Select mode="multiple">
                                        {currencyList
                                            ?
                                            Object.keys(currencyList).map((item, index) => (
                                                <Option key={index} value={currencyList[index].numeric3}> {currencyList[index].name} - {currencyList[index].alpha3} - {currencyList[index].numeric3} </Option>
                                            ))
                                            : null
                                        }
                                    </Select>
                                </Form.Item>
                            </> : null
                        }

                        {
                            // Fields to display for sysadmin
                            GroupAccess('SYSADMIN') ? <>
                                {/* DESCRIPTION INPUT */}
                                <Form.Item style={formItemStyle} name="description" label={t('contents._3dsecure_merchant.form.description')}>
                                    <Input />
                                </Form.Item>

                                {/* CONTACT INPUT */}
                                <Form.Item style={formItemStyle} name="contact" label={t('contents._3dsecure_merchant.form.contact')}>
                                    <Input />
                                </Form.Item>

                                {/* REMARKS INPUT */}
                                <Form.Item style={formItemStyle} name="remarks" label={t('contents._3dsecure_merchant.form.remarks')}>
                                    <Input />
                                </Form.Item>

                                {/* STATUS INPUT */}
                                <Form.Item style={formItemStyle} name="status" label={t('contents._3dsecure_merchant.form.status')} rules={[{ required: true, message: t('required_field') }]}>
                                    <Select
                                        placeholder={t('please_select')}
                                        showSearch
                                        optionFilterProp="children"
                                        optionLabelProp="children"
                                    >
                                        <Option key="active" value="active"> {t('contents._3dsecure_merchant.form.status_option_active')} </Option>
                                        <Option key="deactivated" value="deactivated"> {t('contents._3dsecure_merchant.form.status_option_deactivated')} </Option>
                                    </Select>
                                </Form.Item>
                            </>
                                : null
                        }
                    </Col>

                </Row>

                <Tabs defaultActiveKey="1" type="card">
                    {
                        // Fields to display for sysadmin
                        GroupAccess('SYSADMIN') ?
                            <>
                                <Tabs.TabPane tab="Details" key="Details" forceRender='true'>

                                    {/* VERBOSE MODE INPUT */}
                                    <Form.Item label={t('contents._3dsecure_merchant.form.verbose_mode')} name="verbose" valuePropName="checked" style={{ marginBottom: ".5rem" }}>
                                        <Checkbox />
                                    </Form.Item>

                                    {/* CLIENT MODE INPUT */}
                                    <Form.Item name="client_mode" label={t('contents._3dsecure_merchant.form.client_mode')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {clientModeOption.map((item, index) => (
                                                <Option key={item.key} value={item.value}> {item.label} </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    {/* ENABLE RESULT */}
                                    <Form.Item name="enable_result" label={t('contents._3dsecure_merchant.form.enable_result')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {enableResultOption.map((item, index) => (
                                                <Option key={item.key} value={item.value}> {item.label} </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    {/* DISABLE CHALLENGE */}
                                    <Form.Item name="disable_challenge" label={t('contents._3dsecure_merchant.form.disable_challenge')}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {disableChallengeOption.map((item, index) => (
                                                <Option key={item.key} value={item.value}> {item.label} </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    {/* REQUESTOR NAME */}
                                    <Form.Item style={formItemStyle} name="requestor_name" label={t('contents._3dsecure_merchant.form.requestor_name')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Input />
                                    </Form.Item>

                                    {/* REQUESTOR URL */}
                                    <Form.Item style={formItemStyle} name="requestor_url" label={t('contents._3dsecure_merchant.form.requestor_url')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Input />
                                    </Form.Item>

                                    {/* 3DS Requestor Authentication Indicator */}
                                    <Form.Item name="authentication_ind" label={t('contents._3dsecure_merchant.form.3DS_requestor_authentication_indicator')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {authenticationIndicatorOption.map((item, index) => (
                                                <Option key={item.key} value={item.value}> {item.label} </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    {/* 3DS Requestor Challenge Indicator */}
                                    <Form.Item name="challenge_ind" label={t('contents._3dsecure_merchant.form.3DS_requestor_challenge_indicator')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {challengeIndicatorOption.map((item, index) => (
                                                <Option key={item.key} value={item.value}> {item.label} </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    {/* Acct Type */}
                                    <Form.Item name="acct_type" label={t('contents._3dsecure_merchant.form.acct_type')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {accountTypeOption.map((item, index) => (
                                                <Option key={item.key} value={item.value}> {item.label} </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    {/* Acquirer Merchant ID Password */}
                                    <Form.Item style={formItemStyle} name="acquirer_merchant_pwd" label={t('contents._3dsecure_merchant.form.acquirer_merchant_id_password')}>
                                        <Input />
                                    </Form.Item>

                                    {/* Merchant Category Code */}
                                    <Form.Item style={formItemStyle} name="mcc" label={t('contents._3dsecure_merchant.form.merchant_category_code')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Input />
                                    </Form.Item>

                                    {/* Merchant Country Code */}
                                    <Form.Item style={formItemStyle} name="merchant_country_code" label={t('contents._3dsecure_merchant.form.merchant_country_code')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {countryList
                                                ?
                                                Object.keys(countryList).map((item, index) => (
                                                    <Option key={index} value={countryList[index].abrv_numeric}> {countryList[index].name} - {countryList[index].abrv_numeric} </Option>
                                                ))
                                                : null
                                            }
                                        </Select>
                                    </Form.Item>

                                    {/* Message Category */}
                                    <Form.Item name="message_category" label={t('contents._3dsecure_merchant.form.message_category')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {messageCategoryOption.map((item, index) => (
                                                <Option key={item.key} value={item.value}> {item.label} </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    {/* Purchase Currency */}
                                    <Form.Item style={formItemStyle} name="purchase_currency" label={t('contents._3dsecure_merchant.form.purchase_currency')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            showArrow="true"
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {currencyList
                                                ?
                                                Object.keys(currencyList).map((item, index) => (
                                                    <Option key={index} value={currencyList[index].numeric3}> {currencyList[index].name} - {currencyList[index].alpha3} - {currencyList[index].numeric3} </Option>
                                                ))
                                                : null
                                            }
                                        </Select>
                                    </Form.Item>

                                    {/* Transaction Type */}
                                    <Form.Item name="trans_type" label={t('contents._3dsecure_merchant.form.transaction_type')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {transactionTypeOption.map((item, index) => (
                                                <Option key={item.key} value={item.value}> {item.label} </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    {/* 3DS provider_name */}
                                    <Form.Item style={formItemStyle} name="provider_id" label={t('contents._3dsecure_merchant.form.3ds_provider')} rules={[{ required: true, message: t('required_field') }]}>
                                        <Select
                                            placeholder={t('please_select')}
                                            showSearch
                                            optionFilterProp="children"
                                            optionLabelProp="children"
                                        >
                                            {providers.map((item, index) => (
                                                <Option key={index} value={item.provider_id}> {item.provider_name} </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                </Tabs.TabPane>
                                
                                {
                                    (!merchantData) ? // Show adding of basic bin mid info 
                                        <Tabs.TabPane tab="Bin / Mid Settings" key="Bin / Mid Settings" forceRender='true'>

                                            {/* Visa bin */}
                                            <Form.Item style={formItemStyle} name="visaAcquirerBin" label={t('contents._3dsecure_merchant.form.visa_acquiring_bank_bin')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                            {/* Visa Mid */}
                                            <Form.Item style={formItemStyle} name="visaAcquirerMid" label={t('contents._3dsecure_merchant.form.visa_acquirer_merchant_id')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                            {/* MasterCard Bin */}
                                            <Form.Item style={formItemStyle} name="masterAcquirerBin" label={t('contents._3dsecure_merchant.form.mastercard_acquiring_bank_bin')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                            {/* MasterCard Mid */}
                                            <Form.Item style={formItemStyle} name="masterAcquirerMid" label={t('contents._3dsecure_merchant.form.mastercard_acquirer_merchant_id')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                            {/* JCB BIN */}
                                            <Form.Item style={formItemStyle} name="JCBAcquirerBin" label={t('contents._3dsecure_merchant.form.jcb_acquiring_bank_bin')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                            {/* JCB MID */}
                                            <Form.Item style={formItemStyle} name="JCBAcquirerMid" label={t('contents._3dsecure_merchant.form.jcb_acquirer_merchant_id')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                            {/* CUP BIN */}
                                            <Form.Item style={formItemStyle} name="CUPAcquirerBin" label={t('contents._3dsecure_merchant.form.cup_acquiring_bank_bin')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                            {/* CUP MID */}
                                            <Form.Item style={formItemStyle} name="CUPAcquirerMid" label={t('contents._3dsecure_merchant.form.cup_acquirer_merchant_id')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                            {/* AMEX BIN */}
                                            <Form.Item style={formItemStyle} name="AMEXAcquirerBin" label={t('contents._3dsecure_merchant.form.amex_acquiring_bank_bin')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                            {/* AMEX MID */}
                                            <Form.Item style={formItemStyle} name="AMEXAcquirerMid" label={t('contents._3dsecure_merchant.form.amex_acquirer_merchant_id')}>
                                                <Input disabled={merchantData ? true : false} />
                                            </Form.Item>

                                        </Tabs.TabPane>
                                        : null
                                }
                            </> : null
                    }
                    {
                        (merchantData) ?
                            <Tabs.TabPane tab="API Token" key="API Token" forceRender='true'>

                                <span>
                                    API token
                                    <Button style={{ border: 'none' }}
                                        size="small"
                                        icon={<CopyOutlined style={{ color: "#2989FF" }} />}
                                        onClick={() => {
                                            // Show Toast
                                            notification.success({
                                                message: 'API token copied',
                                                placement: 'bottom',
                                                duration: 1
                                            })
                                            navigator.clipboard.writeText(apiToken);
                                        }}
                                    />
                                </span>

                                <TextArea disabled autoSize={{ minRows: 3, maxRows: 5 }} value={apiToken} />

                                <Button htmlType="button" style={{ marginTop: "10px" }} onClick={generateNewToken} loading={isLoadingGenApiToken} >
                                    {t("contents.profile.form.generate_new_api_token")}
                                </Button>
                            </Tabs.TabPane> : null
                    }
                </Tabs>

            </Form>
        </Modal>
    )
}

export default AddMerchantModal